import { atom } from 'recoil';
import moment from "moment";

export const currentDate = () => {
	const parseDayName = ( dateString ) => {
		const date = new Date( dateString );
		const dayName = date.toLocaleDateString( "en-US", { weekday: "long" } );

		return dayName.toLowerCase();
	};
	const dateStr = new Date();

	return parseDayName( dateStr );
}

const getStartDate = ( dateString ) => {
	const date = dateString ? moment( dateString ) : moment();
	return date.format( "YYYY-MM-DD" );
}

const getStartWeekDate = ( dateString ) => {
	const date = dateString ? moment( dateString ) : moment();
	return date.startOf( "week" ).format( "YYYY-MM-DD" );
}

const endDate = ( dateString ) => {
	const date = dateString ? moment( dateString ) : moment();

	return date.endOf( "week" ).format( "YYYY-MM-DD" );
}

export const userIDState = atom( {
	key: "userID",
	default: '',
} );

export const googleApiKeyState = atom( {
	key: "googleApiKey",
	default: undefined
} );

export const baseLngState = atom( {
	key: "baseLng",
	// default: '31.9638', // Cherkasy
	default: '-122.335', //Seattle
} );

export const baseLatState = atom( {
	key: "baseLat",
	// default: '49.4272', // Cherkasy
	default: '47.597', // Seattle
} );

export const baseIdState = atom( {
	key: "baseId",
	default: '',
} );

export const waypointsState = atom( {
	key: "wayPoints",
	default: [ 'ChIJ0yyXFwhM0UAR45-ibiDOgl8', 'ChIJMWMU1BFL0UAR8KK5o1MVcuk' ],
} );

export const weeklyItineraryState = atom( {
	key: "weeklyItinerary",
	default: [],
} );

export const resourceListState = atom( {
	key: "resources",
	default: undefined,
} );

export const calendarViewState = atom( {
	key: "calendarView",
	default: 'timeGridWeek',
} );

export const dayOfServiceState = atom( {
	key: 'dayOfService',
	default: currentDate()
} )

export const dateOfServiceState = atom( {
	key: 'dateOfService',
	default: getStartDate()
} )

export const dateWeekServiceState = atom( {
	key: 'currentWeekDate',
	default: getStartWeekDate()
} )

export const endDateOfServiceState = atom( {
	key: 'endDateOfService',
	default: endDate()
} )

export const effectiveUtilizationState = atom( {
	key: 'effectiveUtilization',
	default: 1
} )

export const timezoneState = atom( {
	key: 'timezone',
	default: ''
} )

export const urlItinerariesState = atom( {
	key: 'urlItineraries',
	default: ''
} )

export const keyMapState = atom( {
	key: 'keyMap',
	default: 0
} )

export const dayHoverState = atom( {
	key: 'dayHover',
	default: undefined
} )

export const markersListState = atom( {
	key: 'markersList',
	default: []
} )
